/**
 * Tymes4 Backoffice API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type ActivityTypeEnum = 'Logon' | 'Logoff' | 'Customer' | 'Order' | 'Reservation' | 'Event' | 'PassePartout' | 'SalesPeriod' | 'Pricelist' | 'User' | 'InvoiceBatch' | 'PrintBatch' | 'EventPlacement' | 'EventType' | 'PriceComponent' | 'Initiative' | 'Blacklist' | 'BlacklistType' | 'BlacklistReason' | 'DeliveryMethod' | 'Membership' | 'Discount' | 'DiscountCode' | 'SalesChannel' | 'SalesGroup' | 'MailTemplate' | 'Reseller' | 'DatabaseScaleUp' | 'CrossSellProduct' | 'CrossSellProductVariant' | 'EventCrossSellProduct' | 'MarketplacePolicy' | 'MatchDayPass' | 'MatchDayPassEvent' | 'Sector' | 'MatchDayPassPrice' | 'PricingPolicy' | 'MembershipRenewalBatch' | 'MembershipType' | 'AssignmentPolicy' | 'CustomTheme' | 'TenantShop' | 'RuleEngine' | 'TicketChangePolicy' | 'EventTicketChangeSetting';

export const ActivityTypeEnum = {
    Logon: 'Logon' as ActivityTypeEnum,
    Logoff: 'Logoff' as ActivityTypeEnum,
    Customer: 'Customer' as ActivityTypeEnum,
    Order: 'Order' as ActivityTypeEnum,
    Reservation: 'Reservation' as ActivityTypeEnum,
    Event: 'Event' as ActivityTypeEnum,
    PassePartout: 'PassePartout' as ActivityTypeEnum,
    SalesPeriod: 'SalesPeriod' as ActivityTypeEnum,
    Pricelist: 'Pricelist' as ActivityTypeEnum,
    User: 'User' as ActivityTypeEnum,
    InvoiceBatch: 'InvoiceBatch' as ActivityTypeEnum,
    PrintBatch: 'PrintBatch' as ActivityTypeEnum,
    EventPlacement: 'EventPlacement' as ActivityTypeEnum,
    EventType: 'EventType' as ActivityTypeEnum,
    PriceComponent: 'PriceComponent' as ActivityTypeEnum,
    Initiative: 'Initiative' as ActivityTypeEnum,
    Blacklist: 'Blacklist' as ActivityTypeEnum,
    BlacklistType: 'BlacklistType' as ActivityTypeEnum,
    BlacklistReason: 'BlacklistReason' as ActivityTypeEnum,
    DeliveryMethod: 'DeliveryMethod' as ActivityTypeEnum,
    Membership: 'Membership' as ActivityTypeEnum,
    Discount: 'Discount' as ActivityTypeEnum,
    DiscountCode: 'DiscountCode' as ActivityTypeEnum,
    SalesChannel: 'SalesChannel' as ActivityTypeEnum,
    SalesGroup: 'SalesGroup' as ActivityTypeEnum,
    MailTemplate: 'MailTemplate' as ActivityTypeEnum,
    Reseller: 'Reseller' as ActivityTypeEnum,
    DatabaseScaleUp: 'DatabaseScaleUp' as ActivityTypeEnum,
    CrossSellProduct: 'CrossSellProduct' as ActivityTypeEnum,
    CrossSellProductVariant: 'CrossSellProductVariant' as ActivityTypeEnum,
    EventCrossSellProduct: 'EventCrossSellProduct' as ActivityTypeEnum,
    MarketplacePolicy: 'MarketplacePolicy' as ActivityTypeEnum,
    MatchDayPass: 'MatchDayPass' as ActivityTypeEnum,
    MatchDayPassEvent: 'MatchDayPassEvent' as ActivityTypeEnum,
    Sector: 'Sector' as ActivityTypeEnum,
    MatchDayPassPrice: 'MatchDayPassPrice' as ActivityTypeEnum,
    PricingPolicy: 'PricingPolicy' as ActivityTypeEnum,
    MembershipRenewalBatch: 'MembershipRenewalBatch' as ActivityTypeEnum,
    MembershipType: 'MembershipType' as ActivityTypeEnum,
    AssignmentPolicy: 'AssignmentPolicy' as ActivityTypeEnum,
    CustomTheme: 'CustomTheme' as ActivityTypeEnum,
    TenantShop: 'TenantShop' as ActivityTypeEnum,
    RuleEngine: 'RuleEngine' as ActivityTypeEnum,
    TicketChangePolicy: 'TicketChangePolicy' as ActivityTypeEnum,
    EventTicketChangeSetting: 'EventTicketChangeSetting' as ActivityTypeEnum
};

